import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import QtCategoryName from "../../../../visComponents/qtCategoryName";
import {
  addToCart,
  changeActivePartRelatedItemIndex,
  setQtActiveCategory
} from "../../../../../actions/actionFunctions";
import PropTypes from "prop-types";
import {getCurrentLayout} from "../../../../appLayout";
import {
  setSQFTActiveRoomIndex,
  setSQFTActiveRoom,
  setSQFTActiveRoomType, setSQFTActiveRoomId
} from "../../../../../actions/sqftMenuFunctions";
import {getRoomName} from "../../../../../misc/helpers";
import {setActiveQuoteIndex, setQuotes} from "../../../../../actions/roomsFunctions";
import {getFeatureGroup, getNavItems, onSQFTLoadImport, onSQFTLoadPrepareData} from "../../../helpers/sqftHelperUi";
import workspace from "../../canvas/core/workspace";
import {ACTIVE_ROOM_TYPE} from "../../../../../reducers/sqftMenuReducer";
import {injectIntl} from "react-intl";
import {clearAllMenusEvents} from "../../canvas/core/workspace/workspaceEvents";
import QuotesSwitcherListRoomGroups from "./quotesSwitcherListRoomGroups";
import {setNewActiveQuote} from "../../../../../misc/quotesFunctions";
import {shouldSwitchVisualizer, switchToNewVisualizerType} from "../../../../../misc/visualizerSwitchingFunctions";
import {setSqftFromFeature} from "../../../../../actions/sqftFunctions";
import {saveSQFTDataToQuote} from "../../../helpers/sqftQuotesHelper";

const QuotesSwitcherListCategories = (props) => {
  const {visualizersLoaded, activeRoomIndex, cartItems, setSQFTActiveRoomIndex, setSQFTActiveRoomId, quotes,
    setActiveQuoteIndex, setQtActiveCategory, setSQFTActiveRoomType, fabricatorData, intl, fabricatorSettings,
    setSqftFromFeature} = props;
  const {startIndex, baseClass, handleDropDownClick, prepareSQFTData} = props
  const [qtCategories, setQtCategories] = useState(null);
  const layout = getCurrentLayout();

  useEffect(() => {
    if (visualizersLoaded.length) {
      const qtCategories = layout.qtCategories;
      const roomsFeatureGroup = getFeatureGroup('room');
      const roomsNavItems = getNavItems(roomsFeatureGroup, "", false, true);

      if (qtCategories) {
        let categoriesFiltered = layout.qtCategories.filter(qtCategory => {
          const isMatchingWithQuote = quotes.some((quote, quoteIndex) => {
            const roomName = getRoomName(quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData);
            return roomName.includes(qtCategory.name) && quote.isVisibleInSQFT !== false
          })
          const isRoom = !qtCategory.subParts || !qtCategory.subParts.some(subPart => subPart.part.partId === 'room');
          const isRoomGroupExist = roomsNavItems.some(roomsNavItem => {
            return roomsNavItem.part.partName === qtCategory.name
          })
          return isRoom && !isMatchingWithQuote && isRoomGroupExist;
        })
        setQtCategories(categoriesFiltered);
      }
    }

  }, [quotes, cartItems, fabricatorData, visualizersLoaded, intl, layout])

  const handleCategoryClick = async (qtCategory, roomIndex) => {
    handleDropDownClick();
    clearAllMenusEvents();
    await saveSQFTDataToQuote();

    const nextQtCatName = qtCategory.name.trim().toLowerCase();
    const existingQuoteForSelectedCategory = quotes.find(quote => quote.qtCatName === nextQtCatName);
    if (existingQuoteForSelectedCategory) {
      const quoteIndex = quotes.indexOf(existingQuoteForSelectedCategory);
      setActiveQuoteIndex(quoteIndex);
      await setNewActiveQuote(quoteIndex, quotes);
      loadQuoteToSQFT();
    } else {
      workspace.import({});
      const newVisualizer = shouldSwitchVisualizer(null, nextQtCatName, fabricatorSettings, false);
      if (newVisualizer) {
        // add a room cart item here? not sure
        await switchToNewVisualizerType(newVisualizer);
      }
    }
    setSqftFromFeature(null);
    setQtActiveCategory(qtCategory.name);
    setSQFTActiveRoomId(qtCategory.name);
    setSQFTActiveRoomIndex(roomIndex);
    setSQFTActiveRoomType(ACTIVE_ROOM_TYPE.category);
    //setSQFTActiveRoom(qtCategory);
  };

  const loadQuoteToSQFT = () => {
    let payload = onSQFTLoadPrepareData();
    onSQFTLoadImport(payload);
  }

  return (
    qtCategories && qtCategories.length > 0
      ? (qtCategories.map((qtCategory, index) => {
        const roomIndex = index + startIndex;
        const isActive = roomIndex === activeRoomIndex;

        return (
          <li key={"dropdown" + index + startIndex}
              data-index={roomIndex}
              onClick={() => handleCategoryClick(qtCategory, roomIndex)}
              className={baseClass+"__dropdown-list-item categories-item"
              + (isActive ? ` ${baseClass}__dropdown-list-item--active` : "")
              + ` ${baseClass}__dropdown-list-item--${qtCategory.name.toLowerCase().replace(/ /g,"_")}`}>
            <QtCategoryName qtCategoryName={qtCategory.name}/>
          </li>
        )
      })
      )
      : <QuotesSwitcherListRoomGroups baseClass={baseClass}
                                    handleDropDownClick={handleDropDownClick}
                                    startIndex={startIndex}
                                    prepareSQFTData={prepareSQFTData}/>
  )
}

QuotesSwitcherListCategories.propTypes = {
  startIndex: PropTypes.number.isRequired,
  baseClass: PropTypes.string.isRequired,
  handleDropDownClick: PropTypes.func.isRequired,
  prepareSQFTData: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => ({
  quotes: store.quotesState.quotes,
  qtActiveCategory: store.qtState.qtActiveCategory,
  activeTheme: store.serverState.activeTheme,
  visualizersLoaded: store.serverState.visualizersLoaded,
  fabricatorSettings: store.fabricatorState.settings,
  fabricatorData: store.fabricatorState,
  cartItems: store.cartState.cartItems,
  activeRoom: store.sqftMenuState.activeRoom,
  activeRoomId: store.sqftMenuState.activeRoomId,
  activeRoomType: store.sqftMenuState.activeRoomType,
  activeRoomIndex: store.sqftMenuState.activeRoomIndex,
})

const mapDispatchToProps = {
  setQtActiveCategory,
  changeActivePartRelatedItemIndex,
  setSQFTActiveRoomId,
  setSQFTActiveRoomIndex,
  setSQFTActiveRoomType,
  setSQFTActiveRoom,
  setQuotes,
  setActiveQuoteIndex,
  addToCart,
  setSqftFromFeature,
}

export default injectIntl (
  connect(mapStateToProps, mapDispatchToProps)(QuotesSwitcherListCategories)
);
